import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IRaisonImmobilisation } from '../models/raison-immobilisation.model';
import { InlineResponse } from '../models/inline-response.model';
import { ILieuImmobilisation } from '../models/lieu-immobilisation.model';
import { RaisonImmobilisation } from '../../features/parameters/referentials/referentials-immobilisation-demande/raison-immobilisation.model';
import { LieuImmobilisation } from '../../features/parameters/referentials/referentials-immobilisation-demande/lieu-immobilisation.model';
import { environment } from '../../../environments/environment';

const options = {
  headers: new HttpHeaders({
    'Content-Type': 'application/x-www-form-urlencoded',
  }),
};

@Injectable({
  providedIn: 'root',
})
export class ImmobilisationDemandeClientService {
  private apiUrl = environment.apiURL + '/services/';

  constructor(private http: HttpClient) {}

  public getAllRaisonImmobilisation(): Observable<IRaisonImmobilisation> {
    return this.http.get<IRaisonImmobilisation>(this.apiUrl + 'raisonImmobilisation');
  }

  public getRaisonImmobilisationById(idRaisonImmobilisation: number): Observable<IRaisonImmobilisation> {
    return this.http.get<IRaisonImmobilisation>(this.apiUrl + 'raisonImmobilisation' + `/${idRaisonImmobilisation}`);
  }

  public addRaisonImmobilisation(raison: string): Observable<InlineResponse> {
    let params = new HttpParams()
      .set('raison', raison)
      .set('id', (Math.floor(Math.random() * (999999999 - 1111111 + 1)) + 1111111).toString())
      .set('oper', 'add');

    return this.http.post<InlineResponse>(this.apiUrl + 'raisonImmobilisation', params, options);
  }

  public updateRaisonImmobilisation(raisonImmobilisation: RaisonImmobilisation): Observable<InlineResponse> {
    let params = new HttpParams().set('raison', raisonImmobilisation.raison).set('id', raisonImmobilisation.id).set('oper', 'edit');

    return this.http.post<InlineResponse>(this.apiUrl + 'raisonImmobilisation', params, options);
  }

  public getAllLieuImmobilisation(): Observable<ILieuImmobilisation> {
    return this.http.get<ILieuImmobilisation>(this.apiUrl + 'lieuImmobilisation');
  }

  public getLieuImmobilisationById(idLieuImmobilisation: number): Observable<ILieuImmobilisation> {
    return this.http.get<ILieuImmobilisation>(this.apiUrl + 'lieuImmobilisation' + `/${idLieuImmobilisation}`);
  }

  public addLieuImmobilisation(lieu: string): Observable<InlineResponse> {
    let params = new HttpParams()
      .set('lieu', lieu)
      .set('id', (Math.floor(Math.random() * (999999999 - 1111111 + 1)) + 1111111).toString())
      .set('oper', 'add');

    return this.http.post<InlineResponse>(this.apiUrl + 'lieuImmobilisation', params, options);
  }

  public updateLieuImmobilisation(lieuImmobilisation: LieuImmobilisation): Observable<InlineResponse> {
    let params = new HttpParams().set('lieu', lieuImmobilisation.lieu).set('id', lieuImmobilisation.id).set('oper', 'edit');

    return this.http.post<InlineResponse>(this.apiUrl + 'lieuImmobilisation', params, options);
  }
}
